// extracted by mini-css-extract-plugin
module.exports = {"proforma-invoice":"ProformaInvoice_proforma-invoice__DtEvy","container":"ProformaInvoice_container__U8f1n"};